// component specific js
$(document).ready(function(){
    // Append link to launch native app
    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };

    //IE nonsense
    var doc = document.documentElement;
    doc.setAttribute('data-useragent', navigator.userAgent);

    var nVer = navigator.appVersion;

    $('.map-outer-div-experimental').each(function(){
        var el = $(this),
            lat_coords = el.attr('data-latitude'),
            long_coords = el.attr('data-longitude');

        if(isMobile.any()){
            if(isMobile.Android()){
                var mapLink = 'geo:'+ lat_coords +','+long_coords;
            } else if (isMobile.iOS()) {
                if (/(iPhone|iPad|iPod)\sOS\s6/.test(navigator.userAgent)){
                    var mapLink = 'maps://?q='+ lat_coords +','+long_coords;
                } else {
                    var mapLink = 'comgooglemaps://?q='+ lat_coords +','+long_coords;
                }
            } else if (isMobile.Windows()) {
                var mapLink = 'maps://?q='+ lat_coords +','+long_coords;
            }
            el.append('<section class="map-links"><a href="'+mapLink+'" data-rel="external">Launch Your Maps App</a></section>');
        }

    });

});

$(function(){

    //form validation
    if($('form').length>0) {
        $('form').parsley({
            successClass: "success",
            errorClass: "error",
            classHandler: function (el) {
                return el.$element.closest('.field');
            },
            errorsContainer: function (el) {
                return el.$element.closest('.field');
            },
            errorsWrapper: '<ul class="errors-list"></ul>'
        });
    }

    $('.has-other').each(function(){
        var wrapper = $(this);
        wrapper.find('input[type="radio"]').on('change', function(){
            var input = $(this);
            if(input.is(':checked')) {
                if(input.hasClass('needs-other')) {
                    input.next('.other-field').show();
                } else {
                    wrapper.find('.other-field').hide();
                }
            }
        });

        wrapper.find('input[type="checkbox"]').on('change', function(){
            var input = $(this);
            if(input.is(':checked')) {
                if(input.hasClass('needs-other')) {
                    input.next('input').show();
                }
            } else {
                if(input.hasClass('needs-other')) {
                    input.next('input').hide();
                }
            }
        });
    });

    $('.promo-trigger').on('click', function(e){
        e.preventDefault();
        var el = jQuery(this);
        if(el.hasClass('active')) {
            el.removeClass('active');
            el.find('.fa').removeClass('fa-caret-up').addClass('fa-caret-down');
            el.next('.flyout-wrapper').slideUp('fast');
        } else {
            el.addClass('active');
            el.find('.fa').removeClass('fa-caret-down').addClass('fa-caret-up');
            el.next('.flyout-wrapper').slideDown('fast').css('overflow', 'visible');
        }
    });

    $('.promo-close').on('click', function(e) {
        e.preventDefault();
        $('.promo-trigger').click();
    });

    $('.form-heading h2').on('click', function(e){
        e.preventDefault();
        var el = jQuery(this);
        if (el.parent().hasClass('active')) {
            el.find('.fa').removeClass('fa-angle-up').addClass('fa-angle-down');
            el.parent().removeClass('active').next('.dropdown').slideUp();
        } else {
            el.find('.fa').removeClass('fa-angle-down').addClass('fa-angle-up');
            el.parent().addClass('active').next('.dropdown').slideDown();
        }
    });

    // rather than grab a larger modernizr custom
    $.support.placeholder = ('placeholder') in document.createElement('input');
    $('form').each(function(){
        if(!$.support.placeholder) {
            $(this).addClass('no-placeholder');
        }
    });

    // inset rotation
    $('.inset').each(function(){
        var $inset = $(this);
        if($inset.find('img').length > 1) {
            $inset.slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 500
            });
        }
    });

    // sabre custom pickadate //
    if($.fn.pickadate && $('.pickadate-sabre').length) {
        var d = new Date();
        var weekday = $.fn.pickadate.defaults.weekdaysFull;
        var month = $.fn.pickadate.defaults.monthsFull;
        var weekdayAbbr = $.fn.pickadate.defaults.weekdaysShort;
        var monthAbbr = $.fn.pickadate.defaults.monthsShort;
        var setAltInput = function(date, altClass) {
            var dateNum = date.getDate();
            var dateDay = weekday[date.getDay()];
            var dateMonth = month[date.getMonth()];
            var abbrDay = weekdayAbbr[date.getDay()];
            var abbrMonth = monthAbbr[date.getMonth()];
            $('.' + altClass + ' .date-top').html(abbrDay);
            $('.' + altClass + ' .date-left').html(dateNum);
            $('.' + altClass + ' .date-right').html(abbrMonth);
        };
        var standalone_$input = $('.date-standalone').pickadate({
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy',
            today: '',
            clear: '',
            min: [d.getFullYear(), d.getMonth(), d.getDate()]
        }),
        standalone = standalone_$input.pickadate('picker');


         var custom_$input = $('.date-custom').pickadate({
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy',
            today: '',
            clear: '',
            min: 5
        }),
        custom = custom_$input.pickadate('picker');

        var from_$input = $('.date-begin').pickadate({
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy',
            today: '',
            clear: '',
            min: [d.getFullYear(), d.getMonth(), d.getDate()]
        }),

        from_picker = from_$input.pickadate('picker');

        var to_$input = $('.date-end').pickadate({
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy',
            today: '',
            clear: ''
        }),
          to_picker = to_$input.pickadate('picker');

        $('.date-begin').each(function(){
            if (from_picker.get('value')) {
                to_picker.set('min', from_picker.get('select'));
            }

            var nextDay;
            from_picker.on('set', function(event) {
                var fromDate = from_picker.get('select', 'yyyy/mm/dd');
                var selected = new Date(fromDate);
                nextDay = new Date(selected.getTime() + (24 * 60 * 60 * 1000));
                if (event.select) {
                  to_picker.set('min', nextDay);
                  setAltInput(selected, 'alt-input-begin');
                }
            });
            from_picker.on('close', function(event) {
             if (from_picker.get('select') >= to_picker.get('select')) {
                to_picker.set('select', nextDay);
             }
            });

            from_picker.set('select', d);
        });
        $('.date-end').each(function(){
            to_picker.on('set', function(event) {
                if (to_picker.get('select')==null) {
                    var toDate = to_picker.get('min', 'yyyy/mm/dd');
                } else {
                    var toDate = to_picker.get('select', 'yyyy/mm/dd');
                }
                var selected = new Date(toDate);
                var prevDay = new Date(selected.getTime() - (24 * 60 * 60 * 1000));
                if (event.select) {
                  setAltInput(selected, 'alt-input-end');
                }
                setAltInput(selected, 'alt-input-end');
            });
            to_picker.set('select', d.getTime() + (24 * 60 * 60 * 1000));
        });

        $('.alt-input-begin').on('click', function(e) {
            from_picker.open();
            e.stopPropagation();
        });
        $('.alt-input-end').on('click', function(e) {
            to_picker.open();
            e.stopPropagation();
        });
        $('.alt-input-begin a, .alt-input-end a').click(function(e) {
            e.preventDefault();
        });
    }
    // end sabre custom pickadate //

    // single pickadate, no departure //

    if($.fn.pickadate && $('.pickadate-single').length) {
        var d = new Date();
        var weekday = $.fn.pickadate.defaults.weekdaysFull;
        var month = $.fn.pickadate.defaults.monthsFull;
        var weekdayAbbr = $.fn.pickadate.defaults.weekdaysShort;
        var monthAbbr = $.fn.pickadate.defaults.monthsShort;
        var from_$input = $('.date-begin').pickadate({
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy',
            today: '',
            clear: '',
            min: [d.getFullYear(), d.getMonth(), d.getDate()]
        }),
        from_picker = from_$input.pickadate('picker');
        from_picker.set('select', d);
    }

    // enable pickadate timepicker //
    if($.fn.pickatime && $('.pickatime-sabre').length) {
        $('.time-picker').pickatime();
    }

    // offer category filtering [non-ajax]
    $('.category-filter').on('click', 'a', function(e){
        e.preventDefault();
        var el = $(this);
        if(el.parent().hasClass('active')) {
            el.parent().removeClass('active');
            el.children('span').removeClass('fa-check-square-o').addClass('fa-square-o');
            $('.offers-listing').each(function(){
                var category = el.attr('data-category'),
                    listing = $(this);
                listing.find('li').each(function(){
                    var offer = $(this);
                    if(offer.attr('data-category') == category)
                        $(this).hide();
                });
                if($(this).find('li:visible').length === 0)
                    listing.find('.message').css('display','block');
            });

        } else {
            el.parent().addClass('active');
            el.children('span').removeClass('fa-square-o').addClass('fa-check-square-o');
            $('.offers-listing').each(function(){
                var category = el.attr('data-category'),
                    listing = $(this);
                listing.find('li').each(function(){
                    var offer = $(this);
                    if(offer.attr('data-category') == category)
                        $(this).show();
                    listing.find('.message').css('display','none');
                });
            });
        }
    });

    // toggle with button text
    $('.expand-toggle').click(function(e) {
        e.preventDefault();
        var el = $(this);
        if(el.parent().hasClass('active')){
            el.parent().removeClass('active');
            el.text(el.data('toggle-open'));
            el.parent().siblings('.expandable').slideUp(function() {
                if ($(el.parent().siblings('.expandable-intro')).length>0) {
                    $(el.parent().siblings('.expandable-intro')).hide();
                }
            });
        } else {
            el.parent().addClass('active');
            el.text(el.data('toggle-close'));
            el.parent().siblings('.expandable').slideDown();
            if ($(el.parent().siblings('.expandable-intro')).length>0) {
                $(el.parent().siblings('.expandable-intro')).show();
            }
        }
    });

    $('.info-button').on('click', function() {
        $(this).unbind('onmouseover').unbind('onmouseout');
        $(this).removeClass('hover');
    });

    // generic toggler
    $('.next-sibling-toggle a').first().click(function(e) {
        e.preventDefault();
        $(this).toggleClass('activated');
        //$(this).parents('.next-sibling-toggle').next('.sibling-togglable').toggleClass('hidden');
        $(this).parents('.next-sibling-toggle').children('.sibling-togglable').toggleClass('hidden')
    });

    $('#open-advanced').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('activated');
        $('#advanced').toggle();
    });


});